import { faFileMedicalAlt } from "@elynx/free-solid-svg-icons";
import { Box, Typography } from "@mui/material";
import { format } from "date-fns/format";
import { useTranslation } from "react-i18next";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { IObjectHistoryDataQualityEventItem } from "../../queries/object-history/Common";
import { ObjectHistoryCard } from "./ObjectHistoryCard";
import { ObjectHistoryCardContent } from "./ObjectHistoryCardContent";
import { ObjectHistoryCardHeader } from "./ObjectHistoryCardHeader";
import { ObjectHistoryCardSubheader } from "./ObjectHistoryCardSubheader";
import { ObjectHistoryEventItemAvatar } from "./ObjectHistoryEventItemAvatar";
import { getEventEndSummaryText, getEventEndSynopsisText, getEventStartSynopsisText } from "./ObjectHistoryUtils";

export type ObjectHistoryDataQualityEventItemProps = {
    item: IObjectHistoryDataQualityEventItem;
    contextObject?: IeLynxObject;
};

export function ObjectHistoryDataQualityEventItem({ item, contextObject }: ObjectHistoryDataQualityEventItemProps) {
    const { t } = useTranslation();
    //const theme = useTheme();

    return (
        <ObjectHistoryCard>
            <ObjectHistoryCardHeader
                title={format(item.timestamp, "P pp")}
                avatar={<ObjectHistoryEventItemAvatar item={item} icon={faFileMedicalAlt} />}
                subheader={
                    <ObjectHistoryCardSubheader
                        item={item}
                        createdBy={item.createdBy}
                        contextObject={contextObject}
                    />
                }
            >
            </ObjectHistoryCardHeader>
            <ObjectHistoryCardContent>
                {item.isStart
                    ? <Typography variant="body2">
                        {getEventStartSynopsisText(item)}
                        <Box component="span" style={{ fontWeight: "bold" }}>{`${item.ruleName}`}</Box>
                        {item.tagName &&
                            <>
                                {` ${t("objectHistory.eventItem.on")} `}
                                <Box component="span" style={{ fontWeight: "bold" }}>
                                    {item.tagName}
                                </Box>
                            </>
                        }.
                    </Typography>
                    : <>
                        <Typography variant="body2">{getEventEndSynopsisText(item)}</Typography>
                        <Typography variant="body2">
                            <Box component="span" style={{ fontWeight: "bold" }}>
                                {item.ruleName}
                            </Box>
                            {item.tagName &&
                                <>
                                    {` ${t("objectHistory.eventItem.on")} `}
                                    <Box component="span" style={{ fontWeight: "bold" }}>
                                        {item.tagName}
                                    </Box>
                                </>
                            }
                            {getEventEndSummaryText(item)}
                        </Typography>
                    </>
                }
            </ObjectHistoryCardContent>
        </ObjectHistoryCard>
    );
}
